import {
    showTitleConfirm,
    showWarnMessage
} from '../../../../_shared/Messages/actions/MessageActions';
import {messagesIds} from '../../../../_shared/Messages/consts';

/* title change */
export function changeTitle(field, newTitle, cancelCallback, errMsg, setTitleSrv?) {
    const title = newTitle.trim();
    const double = field.doesTitleNeedChecks && field.isNewNameDouble(newTitle);
    if (double) {
        if (!field.isDoubleTitleAllowed) {
            showWarnMessage({
                id: messagesIds.screens.changeFieldTitleWarn,
                title: errMsg,
                onClose: cancelCallback
            });
        } else {
            showTitleConfirm(
                messagesIds.screens.changeFieldTitleConfirm,
                field.title,
                () => setNewTitle(field, title),
                cancelCallback
            );
        }
    } else if (title.length > 0) {
        setTitleSrv && setTitleSrv(title);
        setNewTitle(field, title);
    } else {
        field.cancelTitleChange();
    }
}

export function startTitleEdit(field) {
    field.setChanging(true);
}

export function setNewTitle(field, title) {
    field.setTitle(title);
    finishTitleChange(field);
}

export function finishTitleChange(field) {
    const {screen} = field;
    if (!screen.changed) {
        screen.setChanged(true);
    }
    field.setChanging(false);
}

export function cancelTitleChange(field) {
    field.cancelTitleChange();
}

/* hide */
export function hideOrShowActiveField(field) {
    const {screen} = field;
    if (!screen.changed) {
        screen.setChanged(true);
    }
    field.toggleHide();
}
